




















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import User from "../../../store/entities/user";
import ChangePassword from "./update-password.vue";
@Component({
  components: { ChangePassword },
})
export default class UserProfile extends AbpBase {
  changePasswordModalShow: boolean = false;
  user: User = new User();

  userRule = {
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    surname: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Surname")),
        trigger: "blur",
      },
    ],
    phoneNumber: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("PhoneNumber")),
        trigger: "blur",
      },
    ],
    emailAddress: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Email")),
        trigger: "blur",
      },
      { type: "email" },
    ],
  };
  async created() {
    this.user = await this.$store.dispatch({
      type: "session/getCurrentUserInformation",
    });
  }
  reset(){
    this.changePasswordModalShow = true;
  }
  save() {
    (this.$refs.userForm as any).validate(async (valid: boolean) => {
      if (valid) {
        var res = await this.$store.dispatch({
          type: "session/updateCurrentUserInformation",
          data: this.user,
        });
        this.$Message.success(this.L("SuccessUpdate"));
      }
    });
  }
}
